<div class="modelContainer alignCenter" *ngIf="isLoader==false">
  <div *ngIf="isLoader" class="svg-loader"></div>
  <div class="">
    <button (click)="onCancelClick(true)" type="button" class="close cancelBtn" typeof="button" aria-label="Close"
      mat-dialog-close>
      Close
    </button>
  </div>
  <div class="modelTitle">
    Evaluate Formula
  </div>

  <div class="modelBody" mat-dialog-content>
    <form [formGroup]="formulaBuilderForm">
      <div class=" row">
        <div class="col-md-3 d-flex flex-column">
          <label for="formulaName" class="mb-2">Name: </label>
          <span class="fbControlFormulaName" name="formulaName">{{mainFormulaName}}</span>
        </div>
        <div class="col-md-2 d-flex flex-column">
          <label for="frequency" class="mb-2">Frequency (mins): </label>
          <span class="" name="frequency">{{mainFormulaFrequency}}</span>
        </div>
        <div class="col-md-3 d-flex flex-column">
          <label class="mb-2" for="startTime">Start Time: </label>
          <input id="startTime" [readonly]="true" formControlName="startTime" [owlDateTime]="dt1"
            [owlDateTimeTrigger]="dt1" autocomplete="off" placeholder="From" class=" form-control mb-1" [min]="minDt"
            [max]="maxDt" (dateTimeChange)="updateEndDate(dt1)" />
          <owl-date-time #dt1></owl-date-time>
        </div>
        <div class="col-md-3 d-flex flex-column">
          <label class="mb-2" for="endTime">End Time: </label>
          <input id="endTime" formControlName="endTime" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2"
            autocomplete="off" placeholder="To" class=" form-control mb-1" [min]="toMinDt" [max]="toMaxDt" disabled />
          <owl-date-time #dt2></owl-date-time>
        </div>
        <div class="col-md-1 d-flex flex-column">
          <label class="mb-2 fbLabelControlSiConversion" for="siConversion">
            Ignore SI
          </label>
          <label for="siConversion" name="siConversion" class="switch  fbControlSiConversion">
            <input id="siConversion" type="checkbox" [checked]="mainFormulaIgnoreSi" disabled="disabled">
            <span class="slider round"></span>.
          </label>
        </div>
      </div>
      <br />
      <div class=" row">
        <div class="col-md-1">
          <label class="" for="expression">Expression: </label>
        </div>
        <div class="col-md-11 labelFormulaExpression ">
          <textarea class="form-control" rows="3" disabled="disabled">{{mainFormulaExpression}}</textarea>
        </div>

      </div>
      <div class="d-flex table-container fixed-height-evaluate-formula">
        <div class="col-12 evaluateTable">
          <mat-table [ngClass]="{'output_tbl': isTypeOIAdded == true }" [dataSource]="formulaDataSource" matSort
            matSortActive="tags" matSortDirection="asc" matSortDisableClear>
            <ng-container matColumnDef="ConstantTag">
              <mat-header-cell *matHeaderCellDef class="heading2 custom-table-header">Constants / Tags</mat-header-cell>
              <mat-cell *matCellDef="let element let rowIndex = index" class="regularText custom-mat-cell">
                <span class="">{{element.ConstantTag}}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="ValueDataSource">
              <mat-header-cell *matHeaderCellDef class="heading2 custom-table-header">Value / Data Source</mat-header-cell>
              <mat-cell *matCellDef="let element let rowIndex = index" class="regularText custom-mat-cell">
                <span *ngIf="element.EntryType == 'C'" class="">{{element.ValueDataSource}}</span>
                <span *ngIf="element.EntryType == 'I'" class="">{{element.ValueDataSource}}</span>

                <input *ngIf="element.EntryType == 'T' && element.isDisabled == true" [disabled]="element.isDisabled"
                  value="{{element.ValueDataSource}}" type="text" class="form-control" />
                <input *ngIf="element.EntryType == 'T' && element.isDisabled == false" [disabled]="element.isDisabled"
                  value="{{element.ValueDataSource}}" (keyup)="updateTagValue(element, $event.target.value)"
                  type="number" class="form-control" />

                <span *ngIf="element.EntryType == 'O'" class="">{{element.ValueDataSource}}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="UOM">
              <mat-header-cell *matHeaderCellDef class="heading2 custom-table-header">UOM</mat-header-cell>
              <mat-cell *matCellDef="let element let rowIndex = index" class="regularText custom-mat-cell">
                <span class="">{{element.UOM}}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="EntryType">
              <mat-header-cell *matHeaderCellDef class="heading2 custom-table-header">Manual Entry</mat-header-cell>
              <mat-cell *matCellDef="let element let rowIndex = index" class="regularText custom-mat-cell">
                <label for="manualEntry" *ngIf="element.EntryType == 'T'" name="manualEntry" class="switch  fbControlSiConversion">
                  <input id="manualEntry" #manualEntry type="checkbox" (change)="enableManualEntry(element)">
                  <span class="slider round"></span>.
                </label>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" stickybits></mat-header-row>
            <mat-row *matRowDef="let rows; columns: displayedColumns;"
              [ngClass]="{'highlight': rows.EntryType == 'O'}"></mat-row>
          </mat-table>
        </div>
      </div>
      <div class="d-flex alignCenter">
        <button id="evaluateBtn" type="submit" class="saveBtn2 primaryBtn mt-2" [disabled]="evaluateClicked"
          (click)="evaluateFormula(); evaluateClicked = true;">
          <i class="icon-refresh icon-spin"></i> Evaluate
        </button>
      </div>
    </form>
  </div>
</div>